import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { AlertCircle } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const DemoModeBanner = () => {
  const [demoMode, setDemoMode] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkDemoMode();
  }, []);

  const checkDemoMode = async () => {
    try {
      const response = await axios.get(`${API}/demo-mode/status`);
      setDemoMode(response.data.demo_mode);
    } catch (error) {
      console.error('Failed to check demo mode:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading || !demoMode) return null;

  return (
    <div className="bg-orange-100 dark:bg-orange-900/30 border-l-4 border-orange-500 p-3 mb-4">
      <div className="flex items-center gap-2">
        <AlertCircle className="w-5 h-5 text-orange-600 dark:text-orange-400" />
        <div>
          <p className="text-sm font-medium text-orange-800 dark:text-orange-200">
            Demo Mode Active
          </p>
          <p className="text-xs text-orange-700 dark:text-orange-300">
            This platform is currently showing demo data for testing purposes
          </p>
        </div>
      </div>
    </div>
  );
};

export default DemoModeBanner;
